import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { storeAuditApi, type AuditTypeValue } from '../api/storeAudit';

const KEYS = {
  list:   (page: number)  => ['store-audits', page] as const,
  latest: ()              => ['store-audits', 'latest'] as const,
  detail: (id: number)    => ['store-audits', id] as const,
};

export function useStoreAudits(page = 1) {
  return useQuery({
    queryKey: KEYS.list(page),
    queryFn:  () => storeAuditApi.list(page),
  });
}

export function useLatestAudit() {
  return useQuery({
    queryKey: KEYS.latest(),
    queryFn:  storeAuditApi.latest,
    retry:    false,
  });
}

export function useStoreAudit(id: number) {
  return useQuery({
    queryKey: KEYS.detail(id),
    queryFn:  () => storeAuditApi.find(id),
    enabled:  id > 0,
  });
}

export function useTriggerAudit() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (types?: AuditTypeValue[]) => storeAuditApi.trigger(types ? { types } : {}),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['store-audits'] });
    },
  });
}
